import React from "react";
import { useSiteMetadata } from "../hooks/use-site-metadata";

export const SEO = ({
  title,
  description,
  pathname,
  children,
}: {
  title?: string;
  description?: string;
  pathname?: string;
  children?: any;
}) => {
  const {
    title: defaultTitle,
    description: defaultDescription,
    image,
    openGraphImage,
    siteUrl,
  } = useSiteMetadata();

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: `${siteUrl}${image}`,
    openGraphImage: `${siteUrl}${openGraphImage}`,
    url: `${siteUrl}${pathname || ``}`,
  };

  return (
    <>
      <title>{seo.title}</title>
      <html lang="en" />
      <meta name="title" content={seo.title} />
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta name="og:type" content="website" />
      <meta name="og:title" content={seo.title} />
      <meta name="og:description" content={seo.description} />
      <meta name="og:image" content={seo.openGraphImage} />
      <meta name="og:url" content={seo.url} />
      {children}
    </>
  );
};
